import {component$} from '@builder.io/qwik';
import {useDocumentHead, useLocation} from '@builder.io/qwik-city';
import {useAgencyId} from '~/routes/layout';

/**
 * The RouterHead component is placed inside of the document `<head>` element.
 */
export const RouterHead = component$(() => {
  const head = useDocumentHead();
  const location = useLocation();
  const agencyId = useAgencyId();

  return (
    <>
      <title>{head.title}</title>

      <link rel="canonical" href={location.url.href} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta property="og:url" content={location.url.href} />
      <link
        rel="icon"
        type="image/svg+xml"
        href={`/images/logos/${agencyId.value}-icon.svg`}
      />

      {head.meta.map((m) => (
        <meta key={m.key} {...m} />
      ))}

      {head.links.map((l) => (
        <link key={l.key} {...l} />
      ))}

      {head.styles.map((s) => (
        <style
          key={s.key}
          {...s.props}
          {...(s.props?.dangerouslySetInnerHTML
            ? {}
            : {dangerouslySetInnerHTML: s.style})}
        />
      ))}

      {head.scripts.map((s) => (
        <script
          key={s.key}
          {...s.props}
          {...(s.props?.dangerouslySetInnerHTML
            ? {}
            : {dangerouslySetInnerHTML: s.script})}
        />
      ))}
    </>
  );
});
